module.exports = __webpack_public_path__ + "static/img/expro-excercise-text.7ba8d58.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/expro-excercise-text.png
// module id = 92
// module chunks = 0